import * as React from 'react';
import { StyleSheet, Platform, TouchableOpacity, Dimensions } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View } from 'native-base';
import Expo from 'expo';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
//import { NavigationActions } from 'react-navigation';
import Modal from '../components/modal';
import KeyHandler from './keyHandler';

//import Modal from 'react-native-modal';

export default class PlusModal extends React.Component {
	timeToString() {
		const date = new Date();
		return date.toISOString().split('T')[0];
	}

	_addReceipt() {
		this.props.navigation.navigate('Entry', {
			addTrans: 'receipt',
			addDate: this.timeToString()
		});

		this.props.closeModal();
	}

	_addExpense() {
		this.props.navigation.navigate('Entry', {
			addTrans: 'expense',
			addDate: this.timeToString()
		});
		this.props.closeModal();
	}

	_goPeople() {
		this.props.navigation.navigate('People');
		this.props.closeModal();
	}
	_goInvoice() {
		this.props.navigation.navigate('Invoice');
		this.props.closeModal();
	}
	_addAsset() {
		this.props.navigation.navigate('Entry', { addTrans: 'asset' });
		this.props.closeModal();
	}

	render() {
		//console.log(this.props);
		const { width, height } = Dimensions.get('screen');
		const landscape = width > height;
		const max = landscape ? height - 10 : width - 10;
		const min = 300;

		const size = Math.max(min, Math.min(max, landscape ? height * 0.5 : width * 0.4));

		return (
			<>
				<KeyHandler plus={() => this._addReceipt()} minus={() => this._addExpense()} navigation={this.props.navigation} />
				<Modal
					animationIn="slideInDown"
					animationOut="slideOutDown"
					entry="top"
					backdropColor="#295670"
					backdropPressToClose
					backButtonClose
					coverScreen
					style={{ width: size, height: size, margin: 'auto' }}
					swipeThreshold={100}
					isOpen={this.props.visible}
					onClosed={this.props.closeModal}
					swipeDirection="down">
					<View style={[styles.outer, { width: size, height: size }]}>
						<View style={{ backgroundColor: 'white', flex: 1, width: '100%' }}>
							<View style={[styles.rowView, { marginBottom: 10 }]}>
								<TouchableOpacity style={[styles.quarter, { marginRight: 5 }]} onPress={() => this._addReceipt()}>
									<Text numberOfLines={1} style={styles.btnTitle}>
										Simple Receipt
									</Text>
									<FontAwesome name={'plus-square-o'} style={styles.middleIcon} />
									<View style={styles.bottomLine}>
										<Icon name={'calendar'} style={styles.bottomIcon} />
										<Text note style={styles.bottomText}>
											In Daily Entries
										</Text>
									</View>
								</TouchableOpacity>
								<TouchableOpacity style={[styles.quarter, { marginLeft: 5 }]} onPress={() => this._addExpense()}>
									<Text numberOfLines={1} style={styles.btnTitle}>
										Simple Expense
									</Text>
									<FontAwesome name={'minus-square-o'} style={styles.middleIcon} />
									<View style={styles.bottomLine}>
										<Icon name={'calendar'} style={styles.bottomIcon} />
										<Text note style={styles.bottomText}>
											In Daily Entries
										</Text>
									</View>
								</TouchableOpacity>
							</View>
							<View style={styles.rowView}>
								<TouchableOpacity style={[styles.quarter, { marginRight: 5 }]} onPress={() => this._goInvoice()}>
									<Text numberOfLines={1} style={styles.btnTitle}>
										Invoice
									</Text>
									<View style={styles.iconss}>
										<FontAwesome name={'file-pdf-o'} style={[styles.middleIcon, { fontSize: 45 }]} />
										<FontAwesome name={'paper-plane-o'} style={{ fontSize: 40, color: '#438eb9', top: -15, left: 20, position: 'relative' }} />
									</View>
									<View style={styles.bottomLine}>
										<Icon name={'person'} style={styles.bottomIcon} />
										<Text note style={styles.bottomText}>
											In People
										</Text>
									</View>
								</TouchableOpacity>
								<TouchableOpacity style={[styles.quarter, { marginLeft: 5 }]} onPress={() => this._addAsset()}>
									<Text style={styles.btnTitle}>Asset</Text>
									<View style={styles.iconss}>
										<Icon name={'car'} style={[styles.middleIcon, { marginTop: -5 }]} />
										<FontAwesome name={'laptop'} style={{ fontSize: 40, color: '#438eb9', top: -25, left: 28, position: 'relative' }} />
									</View>
									<View style={styles.bottomLine}>
										<FontAwesome name={'building'} style={styles.bottomIcon} />
										<Text note style={styles.bottomText}>
											Things you keep
										</Text>
									</View>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</Modal>
			</>
		);
	}
}

const styles = StyleSheet.create({
	component: {
		flex: 1,
		flexDirection: 'column'
	},
	outer: {
		backgroundColor: '#8c8c8c',
		justifyContent: 'center',
		margin: 0,
		padding: 5,
		alignSelf: 'center',
		alignItems: 'center'
	},
	rowView: {
		flexDirection: 'row',
		flex: 1,
		backgroundColor: '#FBFAFA'
	},
	quarter: {
		flex: 1,
		backgroundColor: '#4d4d4d',
		alignItems: 'center',
		justifyContent: 'space-evenly',
		height: '100%',
		margin: 0,
		borderRadius: 0,
		flexDirection: 'column'
	},
	btnTitle: {
		fontSize: 15,
		color: '#438eb9',
		fontWeight: 'bold',
		alignSelf: 'center',
		textAlign: 'center',
		paddingHorizontal: 10,
		overflow: 'hidden',
		flex: 1,
		maxHeight: 25
	},
	bottomLine: {
		flexDirection: 'row'
	},
	bottomIcon: {
		fontSize: 24,
		color: '#d9d9d9',
		marginRight: 10
	},
	bottomText: {
		color: '#d9d9d9',
		marginTop: 4,
		marginBottom: 8
	},
	iconss: {
		width: 70,
		height: 70,
		alignItems: 'center'
	},
	middleIcon: {
		fontSize: 60,
		color: '#a1c7dd'
	}
});
